export default "__VITE_ASSET__CqzOy8cl__"